import React, {Fragment} from "react";
import LoadingSpinnerComponent from "../LoadingSpinnerComponent";
import ToastHelper from "../../utils/ToastHelper";
import S3ViewComponent from "../S3ViewComponent";
import ChatMessageType from "../../domain/Chat/ChatMessageType";
import ChatUserService from "../../services/chat/ChatUserService";
import UserSessionService from "../../services/UserSessionService";

export default class ChatMessagesHistoryView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            gotUsers: false,
            loggedInUserId: UserSessionService.getUser().user.id
        }
    }

    componentDidMount() {
        this.loadData();
    }

    scrollToBottom() {
        if (this.bottomOfPage) {
            this.bottomOfPage.scrollIntoView({behavior: "smooth"});
        }
    }

    onImageLoaded() {
        this.scrollToBottom();
    }

    loadData() {
        let newState = {isLoading: false}
        let userIds = [];

        this.props.conversation.messages.forEach(message => {
            if (!userIds.includes(message.userId)) {
                userIds.push(message.userId);
            }
        })
        if(userIds.length > 0){
            ChatUserService.retrieveUsers(userIds).then(
                response => {
                    if (Array.isArray(response)) {
                        newState.gotUsers = true;
                        newState.users = [];
                        response.forEach(user => {
                            newState.users[user.id] = user;
                        })
                        this.setState(newState, this.scrollToBottom.bind(this));
                    } else {
                        ToastHelper.formatError(response)
                    }
                }
            )
        }else{
            this.setState(newState)
        }
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingSpinnerComponent/>
        }

        return <Fragment>
            <hr/>
            <div style={{
                boxShadow: "rgb(136, 136, 136) 1px 1px 5px",
                borderRadius: "20px",
                padding: "10px",
                fontSize: "14px",
                maxHeight: "70vh",
                minHeight: "300px",
                overflowY: "scroll"
            }}>
                {
                    this.props.conversation.messages.length > 0
                        ? this.renderMessages()
                        : 'No Messages'
                }
                <div ref={(el) => {
                    this.bottomOfPage = el
                }}
                />
            </div>
        </Fragment>
    }

    renderMessages(){
        return <Fragment>
            {
                this.props.conversation.messages.map(message => {
                    return this.renderMessage(message);
                })
            }
        </Fragment>
    }

    renderMessage(message) {
        let loggedInUser = UserSessionService.getUser().user.id

        let chatBackgroundColor = "rgb(84, 156, 109)";
        let borderRadius = "15px 1px 15px 15px";
        if (loggedInUser !== message.userId) {
            chatBackgroundColor = "rgb(118, 122, 119)";
            borderRadius = "1px 15px 15px 15px";
        }

        let chatStyle = {
            backgroundColor: chatBackgroundColor,
            color: "white",
            width: "fit-content",
            maxWidth: "75%",
            minWidth: "20%",
            borderRadius: borderRadius,
            textAlign: "left",
            margin: "0 5px 10px 5px",
            padding: "10px"
        }

        return <Fragment key={'message-' + message.id}>
            {loggedInUser === message.userId ?
                <div style={{display: "flex", flexDirection: "row-reverse"}}>
                    <div style={chatStyle}>
                        <div>
                            {message.type === ChatMessageType.FILE && this.renderFileMessage(message)}
                            {message.type === ChatMessageType.ADMIN && this.renderAdminMessage(message)}
                            {message.type === ChatMessageType.TEXT && this.renderTextMessage(message)}
                        </div>
                        <div style={{
                            position: "relative",
                            bottom: "-5px",
                            color: "#ececec",
                            fontSize: "8pt",
                            textAlign: "right"
                        }}>
                            {message.dateCreated}
                        </div>
                    </div>
                </div>
                :
                <div style={{display: "-ms-flexbox"}}>
                    <div
                        style={{textAlign: "left", fontSize: "12px", color: "rgb(118, 122, 119)", paddingLeft: "12px"}}>
                        {this.state.users[message.userId].nickname}
                    </div>
                    <div style={chatStyle}>
                        <div style={{margin: "auto"}}>
                            {message.type === ChatMessageType.FILE && this.renderFileMessage(message)}
                            {message.type === ChatMessageType.ADMIN && this.renderAdminMessage(message)}
                            {message.type === ChatMessageType.TEXT && this.renderTextMessage(message)}
                        </div>
                        <div style={{
                            position: "relative",
                            bottom: "-5px",
                            color: "#ececec",
                            fontSize: "8pt",
                            textAlign: "left"
                        }}>
                            {message.dateCreated}
                        </div>

                    </div>
                </div>
            }
        </Fragment>
    }

    renderFileMessage(message) {
        return <Fragment>
            <S3ViewComponent metaDataId={message.data} onImageLoaded={this.onImageLoaded.bind(this)}/>
        </Fragment>
    }

    renderTextMessage(message) {
        return <Fragment>{message.data}</Fragment>
    }

    renderAdminMessage(message) {
        return <Fragment>{message.data}</Fragment>
    }
}
